import React from 'react';
import styled from 'styled-components';
import {
    SkeletonBlock,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonTable,
    SkeletonTableRow
} from 'src/components/widgets/skeleton';

const FilterSkeletonRow = styled(SkeletonRow)`
    flex-wrap: wrap;
`;
const TableSkeletonScroll = styled.div`
    overflow-x: auto;
    > div {
        min-width: 780px;
    }
`;

export function AIUsageHistoryContentSkeleton() {
    return (
        <SkeletonStack $gap='18px' aria-hidden='true'>
            <FilterSkeletonRow $gap='8px'>
                {['290px', '190px', '190px', '190px'].map((width, index) => (
                    <SkeletonStack key={index} $gap='6px'>
                        <SkeletonBlock $width='90px' $height='16px' />
                        <SkeletonBlock $width={width} $height='32px' />
                    </SkeletonStack>
                ))}
                <SkeletonBlock $width='110px' $height='32px' />
                <SkeletonBlock $width='70px' $height='32px' />
            </FilterSkeletonRow>
            <SkeletonRow $justify='flex-end' $gap='12px'>
                <SkeletonBlock $width='130px' $height='16px' />
                <SkeletonBlock $width='80px' $height='32px' />
            </SkeletonRow>
            <TableSkeletonScroll>
                <SkeletonTable>
                    {Array.from({ length: 7 }).map((_, index) => (
                        <SkeletonTableRow key={index} $columns='190px minmax(150px, 1fr) minmax(200px, 1.5fr) 90px 100px 130px'>
                            {Array.from({ length: 6 }).map((__, cell) => (
                                <SkeletonBlock key={cell} $width='75%' $height='16px' />
                            ))}
                        </SkeletonTableRow>
                    ))}
                </SkeletonTable>
            </TableSkeletonScroll>
            <SkeletonRow $justify='flex-end' $gap='12px'>
                <SkeletonBlock $width='90px' $height='16px' />
                <SkeletonBlock $width='90px' $height='32px' />
                <SkeletonBlock $width='70px' $height='32px' />
            </SkeletonRow>
        </SkeletonStack>
    );
}

export function AIUsageHistoryPageSkeleton() {
    return (
        <SkeletonPageShell aria-hidden='true' $padding='20px 0'>
            <SkeletonPageHeader>
                <SkeletonStack $gap='8px'>
                    <SkeletonBlock $width='130px' $height='14px' />
                    <SkeletonBlock $width='210px' $height='28px' />
                    <SkeletonBlock $width='min(500px, 100%)' $height='14px' />
                </SkeletonStack>
            </SkeletonPageHeader>
            <AIUsageHistoryContentSkeleton />
        </SkeletonPageShell>
    );
}
